import {
  BlurTrackSprite,
  Experience,
  OverlayTrackSprite,
  Tracking
} from '../types/experience';

export class ImageExperienceParser {
  constructor(protected experience: Experience) {}

  get isSmartCommerce(): boolean {
    return this.experience.metadata.smartcommerce;
  }

  getCalendarDestinationUrls():
    | Tracking['calendarDestinationUrls']
    | undefined {
    return this.experience.metadata.tracking?.calendarDestinationUrls;
  }

  getCalendarClicks(): Tracking['clicks'] | undefined {
    return this.experience.metadata.tracking?.clicks?.filter(
      click => click.type === 'calendar'
    );
  }

  getImageUrl() {
    return this.experience.description.externalAssets.find(
      asset => asset.id === 'asset' && asset.type === 'image'
    )?.url;
  }

  getRatio() {
    return this.experience.description.ratio;
  }

  getContainerPolicy() {
    return this.experience.metadata.containerPolicy;
  }

  getClickUrl() {
    return this.experience.metadata.tracking?.clicks?.[0]?.url || undefined;
  }

  getBackgroundColor() {
    const blurSprites: BlurTrackSprite | undefined = this.getDefaultBlurSprites(
      'blurFrame'
    ) as BlurTrackSprite;

    const backgroundParameters = blurSprites?.externals.parameters;

    return backgroundParameters?.type === 'color'
      ? backgroundParameters.backgroundColor
      : undefined;
  }

  getBlurEffect() {
    const blurSprites: BlurTrackSprite | undefined = this.getDefaultBlurSprites(
      'blurFrame'
    ) as BlurTrackSprite;

    const backgroundParameters = blurSprites?.externals.parameters;

    return backgroundParameters?.isBlurred === true
      ? { show: true, zoom: 1, offsetX: 0, offsetY: 0 }
      : { show: false, zoom: 1, offsetX: 0, offsetY: 0 };
  }

  getClickArea() {
    const overlaySprite:
      | OverlayTrackSprite
      | undefined = this.getDefaultBlurSprites('overlay') as OverlayTrackSprite;

    const clickParameters = overlaySprite?.externals.parameters;

    return {
      heightPercentage: clickParameters?.interaction?.coreZone.height || 100,
      widthPercentage: clickParameters?.interaction?.coreZone.width || 100,
      positionXPercentage: clickParameters?.interaction?.coreZone.x || 0,
      positionYPercentage: clickParameters?.interaction?.coreZone.y || 0
    };
  }

  private getDefaultBlurSprites(
    id: 'blurFrame' | 'overlay'
  ): BlurTrackSprite | OverlayTrackSprite | undefined {
    return this.experience.description.tracks
      .find(t => t.id === 'default')
      ?.layers[0]?.sprites.find(s => s.id === id);
  }
}
